"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _textInputData = require("../constants/textInputData");
var _obj;
var styleOverrides = {
    root: (_obj = {}, _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.root), {
        fontSize: _constants.textInputData.input.size,
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 10,
        paddingRight: 12
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.root, "::after"), {
        content: '""',
        flexShrink: 0,
        display: 'block',
        overflow: 'hidden',
        width: '24px',
        height: '24px',
        background: 'transparent'
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.root, ":focus"), {
        backgroundColor: _constants.colors.primary.light
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.root, ":hover"), {
        backgroundColor: _constants.colors.primary.light
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.selected, ":focus"), {
        backgroundColor: 'transparent'
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.selected, ":hover"), {
        backgroundColor: _constants.colors.primary.light
    }), _define_property(_obj, "&.OriSelectList .".concat(_material.menuItemClasses.selected, "::after"), {
        content: _textInputData.selectedMark
    }), _obj)
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiList.js.map
